const apiHeaders = new Headers({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'X-Shopify-Storefront-Access-Token': window.storefrontApiToken,
})

export const makeRequest = (callback = null, query = {}, variables = {}) => {
  fetch(window.storefrontApiUrl, {
    method: 'POST',
    headers: apiHeaders,
    body: JSON.stringify({ query: query, variables: variables }),
  })
    .then((response) => response.json())
    .then((result) => {
      if (callback) callback(result)
    })
    .catch((e) => {
      console.error(e)
    })
}

const simpleProductResponse = `
  id
  title
  handle
  onlineStoreUrl
  vendor
  tags
  priceRange {
    minVariantPrice {
      amount
    }
  }
  compareAtPriceRange {
    minVariantPrice {
      amount
    }
  }
  images (first: 8) {
    edges {
      node {
        altText
        height
        width
        url
      }
    }
  }
  options (first: 3) {
    name
    values
  }
  variants (first: 12) {
    edges {
      node {
        id
        availableForSale
        selectedOptions { name value }
      }
    }
  }
  disableBIS: metafield(namespace: "custom", key: "back_in_stock") {
    value
  }
`
const groupResponse = `
  group: metafield(namespace: "leftonfriday", key: "product_group") {
    reference {
      ...on Metaobject {
        groupTitle: field(key: "name") {
          value
        }
        breadcrumb: field(key: "breadcrumb") {
          reference {
            ...on Collection {
              title
            }
          }
        }
        siblings: field(key: "product_list") {
          references(first: 50) {
            edges {
              node {
                ... on Product {
                  ${simpleProductResponse}
                }
              }
            }
          }
        }
      }
    }
  }
`
const collectionsResponse = `
  collections (first: 5) {
    edges {
      node {
        title
      }
    }
  }
`

window.productResponse = `
  ${simpleProductResponse}
  ${collectionsResponse}
  ${groupResponse}
`

window.basicProductResponse = `
  ${simpleProductResponse}
`
window.productGroupResponse = `
  ${groupResponse}
  ${collectionsResponse}
`

const productOptionsByName = (options) => {
  const options_by_name = {}
  options.forEach(option => {
    options_by_name[option.name] = {
      option: {
        values: option.values,
      }
    }
  })
  return options_by_name
}

const getImage = (image) => {
  return {
    alt: image.altText,
    aspect_ratio: image.width / image.height,
    width: image.width,
    height: image.height,
    src: image.url,
    preview_image: {
      src: image.url,
    }
  }
}

const getVariant = (variant) => {
  return {
    id: parseInt(variant.id.replace('gid://shopify/ProductVariant/', '')),
    available: variant.availableForSale,
    options: variant.selectedOptions.map(option => option.value),
  }
}

export const makeProduct = (apiProduct, siblings=true) => {
  const variantEdges = apiProduct?.variants?.edges
  return apiProduct ? {
    id: parseInt(apiProduct.id.replace('gid://shopify/Product/', '')),
    available: variantEdges?.filter(edge => edge.node.availableForSale).length > 0,
    defaultVariant: (variantEdges?.filter(edge => edge.node.availableForSale)[0]?.id || variantEdges[0].node.id).replace('gid://shopify/ProductVariant/', ''),
    url: `/products/${apiProduct.handle}`,
    handle: apiProduct.handle,
    title: apiProduct.title,
    tags: apiProduct.tags, 
    variants: variantEdges?.map(edge => getVariant(edge.node)),
    images: apiProduct.images?.edges?.map(edge => getImage(edge.node)),
    options: apiProduct.options.map(option => option.name),
    options_by_name: productOptionsByName(apiProduct.options),
    price: parseFloat(apiProduct.priceRange.minVariantPrice.amount) * 100,
    comparePrice: parseFloat(apiProduct.compareAtPriceRange.minVariantPrice.amount) * 100,
    featured_image: apiProduct.images?.edges?.length > 0 ? getImage(apiProduct.images.edges[0].node) : {},
    categories: apiProduct.collections?.edges?.map(edge => edge.node.title),
    breadcrumb: { title: apiProduct.group?.reference?.breadcrumb?.reference?.title },
    groupTitle: apiProduct.group?.reference?.groupTitle?.value,
    vendor: apiProduct.vendor,
    colorHandle: (apiProduct.options[0]?.values[0] || '').toLowerCase().replace(/[()]/g, '').replace(/[\s\/&]/g, "-").replace(/-+/g, '-'),
    siblings: siblings ? apiProduct.group?.reference?.siblings?.references?.edges?.filter(edge => edge.node.onlineStoreUrl).map(edge => makeProduct(edge.node, false)) : [],
    disableBIS: apiProduct.disableBIS,
  } : null
}